<div style="display: flex; gap: 8px; width: 100%;">
  <mat-form-field appearance="fill" style="width: 50%;">
    <mat-label>Mínimo</mat-label>
    <input matInput type="number" min="0" [(ngModel)]="range.min" (ngModelChange)="onChange()">
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 50%;">
    <mat-label>Máximo</mat-label>
    <input matInput type="number" min="0" [(ngModel)]="range.max" (ngModelChange)="onChange()">
  </mat-form-field>
</div>
